import React from 'react';
import { FloatingHearts } from './FloatingHearts';
import { Reveal } from './Reveal';
import { SlideFrame } from './SlideFrame';
export function LoveSlide() {
  return <SlideFrame data-id="element-251" data-mp="3kfg9a2aluoq0">
      <FloatingHearts data-id="element-252" data-mp="3fm3s2d899k7a" />
      <div className="relative z-10 flex flex-1 flex-col items-center justify-center text-center" data-id="element-253" data-mp="3flbyt924ryk6">
        <div className="h-[clamp(5px,0.55vw,10px)] w-[clamp(48px,5vw,96px)] bg-[#D62B22]" data-id="element-254" data-mp="3am7ryp2oicx0" />
        <h1 className="mt-[3vh] max-w-[92%] font-display text-[clamp(62px,10.5vw,172px)] font-black uppercase leading-[0.84] tracking-[-0.055em]" data-id="element-255" data-mp="35ofxpoekaepn">
          All you need is love.
        </h1>
        <Reveal className="mt-[5vh]" delay={0.2} data-id="element-256" data-mp="2wmpwjquvo1eo">
          <p className="font-display text-[clamp(24px,2.7vw,48px)] font-medium tracking-[-0.025em]" data-id="element-257" data-mp="2wplvniigow4p">
            Because attention makes things thrive.
          </p>
          <p className="mt-[1.5vh] font-sans text-[clamp(15px,1.35vw,24px)] tracking-[0.08em] text-black/55" data-id="element-258" data-mp="uv3am3puewp2">
            Brands. Ideas. Relationships. Conversations.
          </p>
        </Reveal>
      </div>
    </SlideFrame>;
}